import { all } from 'redux-saga/effects'

import assignedTendersSaga from './components/AssignedTenders/components/Table/saga'
import assignedTendersDetailsSaga from './components/AssignedTenders/components/Table/components/Parts/saga'
import assignedTendersPublishersSaga from './components/AssignedTenders/components/Table/components/Publishers/saga'
import wonTendersSaga from './components/WonTenders/components/Table/saga'
import wonTendersDetailsSaga from './components/WonTenders/components/Table/components/Parts/saga'
import wonTendersPublishersSaga from './components/WonTenders/components/Table/components/Publishers/saga'

export default function* procurementSaga() {
    yield all([
        assignedTendersSaga(),
        assignedTendersDetailsSaga(),
        assignedTendersPublishersSaga(),
        wonTendersSaga(),
        wonTendersDetailsSaga(),
        wonTendersPublishersSaga(),
    ])
}
